import { http } from 'utils'

import { SET_TALENT_OPPORTUNITY_BUDGET } from 'vx/mutations'

// Talent opportunity state.
const state = {
  talentOpportunityBudget: []
}

// Talent opportunity state getters.
const getters = {}

// Talent opportunity actions.
const actions = {
  /**
   * Update a talents opportunities.
   *
   * @return Promise
   */
  updateTalentOpportunities ({ commit }, { id, payload }) {
    return http.put(`users/${id}/talent_opportunities`, payload)
  },

  getTalentOpportunityBudget ({ commit }, { id }) {
    return http.get(`users/${id}`)
      .then((response) => {
        commit(SET_TALENT_OPPORTUNITY_BUDGET, response.data.talent_opportunity_budgets)
        return response
      })
  }
}

// Talent opportunity state mutations.
const mutations = {
  [SET_TALENT_OPPORTUNITY_BUDGET] (state, budget) {
    state.talentOpportunityBudget = budget
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
